import { showMessage } from '@/utils';
import ins from './request.js';



export async function getBanners(){
    return await ins.get('/api/banner');
}

// getBanners().then(res => console.log(res));